// extracted by mini-css-extract-plugin
export default {"header":"header_header__HMK2f","logoIcon":"header_logoIcon__Uip7q","goDown":"header_goDown__7HKPf","bokeBallDiv":"header_bokeBallDiv__wvkWg","fadeIn":"header_fadeIn__8YutE"};